/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.levels.controllers', [
  'ui.router',
  'ui.bootstrap',
  'ui.sortable',
  'acme.common.service.api',
  'acme.common.service.config',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.service.userPreferences',
  'acme.common.service.viewState',
  'acme.common.service.themesHelper',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition'
])

.controller('MembershipLevelsController', ['$scope', '$state', '$filter', '$timeout', 
  'ApiService', 
  'PermissionsService', 
  'ConfigService', 'HelpersService', 
  'UserPreferencesService', 
  'GridStateFactory', 
  'GridDefinitionFactory', 
  'NoticeFactory', 
  'ViewStateService',
  'ThemesHelperService',
   function($scope, $state, $filter, $timeout, 
  ApiService, 
  PermissionsService, 
  ConfigService, 
  HelpersService, 
  UserPreferencesService, 
  GridStateFactory, 
  GridDefinitionFactory, 
  NoticeFactory, 
  ViewStateService,
  ThemesHelperService) {

    $scope.membershipLevels = {

      
      model: [],
      viewList: [],
      tabs: [
        {
          name: 'individualAndFamily',
          label: 'Individual & Family'
        },
        {
          name: 'organization',
          label: 'Organizations'
        }
      ],

      searchQuery: '',
      isLoaded: false,
      tab: 'individualAndFamily',
      modelWatcherInitted: false,
      isAuxiliaryMembershipEnabled: false,
      viewId: '',
      gridName: $state.current.name+'.grid0',

      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),

      notice: new NoticeFactory(),
      strip: HelpersService.strip,
      company: ThemesHelperService.getCompany(),

      dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),

      optionsOverride: {
        enableRowSelection: false,
        multiSelect: true,
        noUnselect: false,
        data: 'membershipLevels.model',
        appScopeProvider: {
          remove: function(id) {
            $scope.membershipLevels.remove(id);
          },
          onDblClick: function(row) {
            $scope.membershipLevels.onGridDoubleClick(row);
          },
          onDataGridPaginate: function(newPageNumber, newPageSize) {
            $scope.membershipLevels.onDataGridPaginate(newPageNumber, newPageSize);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.membershipLevels.onDataGridSortChange(grid, columns);
          },
          onDataGridColumnChanged: function(changedColumn, columns) {
            $scope.membershipLevels.onDataGridColumnChanged(changedColumn, columns);
          },
          onDataGridSelectionChange: function (row, e) {
            $scope.membershipLevels.onDataGridSelectionChange(row, e);
          }
        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'Id',
            visible: false
          }
        ]
      },

      sortable: {

        axis: 'y',

        update: function(e, ui) {
          $scope.membershipLevels.onSortableUpdate(e, ui);
        }

      },

      currentGroup: false,
      groupName: '',
      isRegular: true,

      init: function() {
        var viewState = ViewStateService.getState('membership.levels');

        $scope.$emit('Application::contentTitleChange', {
          title: 'Membership Levels',
          buttonRight: {
            permissions: 'MEMBERSHIP_CATEGORY_CREATE',
            label: 'Create Level',
            action: function() {
              $scope.membershipLevels.create();
            }
          }
      
        });

        this.viewId = $state.current.name;

        if (viewState) {
          this.isRegular = !viewState.auxiliary;
        }
        
        if (this.company && this.company.auxiliaryMembership) {
          this.isAuxiliaryMembershipEnabled = this.company.auxiliaryMembership;
        }
      
        if (PermissionsService.check('MEMBERSHIP_CATEGORY_DELETE')) {
          this.optionsOverride.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            width: 80,
            onCellNavClick: function(row, col) {
              $scope.membershipLevels.remove(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents text-center"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>'
          });
        }

        if (PermissionsService.check('MEMBERSHIP_CATEGORY_UPDATE')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'edit',
            displayName: 'Edit',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.membershipLevels.gridDoubleClick(row);
            },
            cellTemplate: '<div class="ui-grid-cell-contents text-center"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">Edit<span class="sr-only"> Details</span></a></div>'
          });
        }

        this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, true);

        $scope.$on('ConfigService::SettingsLoaded', this.onUserPreferencesUpdated);
        $scope.$on('MembershipLevelsSidebar::Error', this.onSidebarError);
        $scope.$on('MembershipLevelsSidebar::Success', this.success.onSidebarSuccess);
        $scope.$on('MembershipLevelsSidebar::Select', this.onSidebarSelect);

        $scope.$watch('membershipLevels.isRegular', function (n, o) {
          if (n !== o) {
            $scope.membershipLevels.getLevels('individualAndFamily');
            if ($scope.membershipLevels.isRegular) {
              $scope.$broadcast('MembershipLevelsSidebar::Reset');
            }
          }
        });

        $scope.$on('$destroy', function() {
          ViewStateService.resetState('membership.levels');
        });

      },

      hasPermission: function(permission) {
        return PermissionsService.check(permission);
      },

      showGroups: function() {
        return this.hasPermission('MEMBERSHIP_LEVEL_COLLECTION_VIEW') && 
                !this.isRegular && 
                this.isTab('individualAndFamily');
      },

      findTab: function(name) {
      
        var i, ii,
            r = false;
      
        for (i=0,ii=this.tabs.length;i<ii;i++) {
          if (this.tabs[i].name === name) {
            r = {
              tab: this.tabs[i],
              index: i
            };
            break;
          }
        }
        
        return r;
        
      },
      
      isTab: function(tab) {
        return (this.tab === tab);
      },

      getTab: function(tab, preventReset) {
        this.tab = tab;
        //Always reset filter when tabs are changed.
        if (!preventReset) {
          this.isRegular = true;
        }
        this.getLevels(tab);
      },

      getLevels: function(group) {

        var props = this.gridState.getGridState();

        props.salesChannels = 'online';
        props.isPublished = '0';
        props.summarize = '1';
        props.pageSize = '-1';
        props.auxiliary = this.isRegular ? '0' : '1';
        if (group) {
          props.membershipLevelGroup = group;
        }
        if (this.currentGroup && this.currentGroup.id) {
          props.collectionId = this.currentGroup.id;
          if (props.excludeLevelsWithACollection) {
            delete(props.excludeLevelsWithACollection);
          }
        } else {
          props.collectionId = '';
          props.excludeLevelsWithACollection = '1';
        }

        if (props.sortField) {
          delete props.sortField;
        }

        if (props.sortDirection) {
          delete props.sortDirection;
        }
        ApiService.membership.categories.list(props).then(this.success.getLevels, this.error.getLevels);

      },
      
      create: function() {
        var self = $scope.membershipLevels, 
          data = {
            group: self.tab,
            auxiliary: !self.isRegular || null,
            groupId: (self.currentGroup && self.currentGroup.id) || null
          };
          
        self.notice.hideErrorMessages();
        self.notice.hideSuccessMessages();

        $state.go('application.membership.levels.create', data);
      },
      
      findLevels: function(id) {
      
        var i, ii,
            r = false,
            self = $scope.membershipLevels;
      
        for (i=0,ii=self.model.length;i<ii;i++) {
          if (self.model[i].id === id) {
            r = {
              category: self.model[i],
              index: i
            };
            break;
          }
        }
        
        return r;
        
      },
      
      remove: function(id) {
      
        var self = $scope.membershipLevels,
            current = self.findLevels(id);
        /*
        self.addModal = $uibModal.open({
          templateUrl: '',
          size: 'md',
          controller: '',
          resolve: {}
        });
      
        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (name) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();
      
          self.isRemoving = true;
          
          // TODO: Call remove API
      
        }, function () {
          // Do nothing
        });
        */
      
      },

      deleteGroup: function() {
        $scope.$broadcast('MembershipLevelsSidebar::Delete', {id: this.currentGroup && this.currentGroup.id});
      },

      editGroup: function(cancel) {
        this.editCurrentGroup = !this.editCurrentGroup;

        if(cancel) {
          this.groupName = '';
        } else {
          this.groupName = angular.copy(this.currentGroup.name);
        }
      },

      saveGroup: function() {
        this.editCurrentGroup = false;
        $scope.$broadcast('MembershipLevelsSidebar::Save', {group: angular.extend(this.currentGroup, {name: this.groupName})});
      },

      getThumbnail: function(level) {

        var r = '';

        if (level &&
            level.images instanceof Array &&
            level.images.length &&
            level.images[0] &&
            level.images[0].thumbnail) {
          r = level.images[0].thumbnail;
        }else{
          r = '/assets/img/global/no-image-landscape.png';
        }

        return r;

      },

      search: function() {
        this.gridState.setPropertyValue('search', this.searchQuery);
        this.getLevels(this.tab);
      },

      move: function(id, direction) {
        var found = this.findLevels(id);

        if (found !== false) {
          this['move' + HelpersService.cap(direction)](found.index);
        }
      },

      moveUp: function(index) {
        var i, ii,
            tmp,
            props = [];

        if (index > 0) {
          tmp = this.model.splice(index, 1)[0];
          this.model.splice(index - 1, 0, tmp);
        }
        for (i=0,ii=this.model.length;i<ii;i++) {
          this.model[i].displayOrder = i + 1;
          props.push({
            levelId: this.model[i].id,
            displayOrder: this.model[i].displayOrder
          });
        }

        if (props instanceof Array && props.length) {
          ApiService.membership.categories.updateDisplayOrder(props).then(this.success.move, this.error.move);
        }

      },

      moveDown: function(index) {
        var i, ii,
            tmp,
            props = [];

        if (index < this.model.length - 1) {
          tmp = this.model.splice(index, 1)[0];
          this.model.splice(index + 1, 0, tmp);
        }
        for (i=0,ii=this.model.length;i<ii;i++) {
          this.model[i].displayOrder = i + 1;
          props.push({
            levelId: this.model[i].id,
            displayOrder: this.model[i].displayOrder
          });
        }

        if (props instanceof Array && props.length) {
          ApiService.membership.categories.updateDisplayOrder(props).then(this.success.move, this.error.move);
        }
      },

      moveSort: function() {
        var i, ii,
            props = [];

        for (i = 0, ii = this.model.length; i < ii; i++) {
          this.model[i].displayOrder = i + 1;
          props.push({
            levelId: this.model[i].id,
            displayOrder: this.model[i].displayOrder
          });
        }

        if (props instanceof Array && props.length) {
          ApiService.membership.categories.updateDisplayOrder(props).then(this.success.move, this.error.move);
        }

      },

      moveManual: function(index) {
        var i, ii,
          tmp;

        if (index !== this.model[index].displayOrder - 1) {
          if (this.model[index].displayOrder < 1) {
            this.model[index].displayOrder = 1;
          } else if (this.model[index].displayOrder > this.model.length) {
            this.model[index].displayOrder = this.model.length;
          }

          if (index < this.model.length) {
            tmp = this.model.splice(index, 1)[0];
            this.model.splice(tmp.displayOrder - 1, 0, tmp);
          }

          for (i = 0, ii = this.model.length; i < ii; i++) {
            this.model[i].displayOrder = i + 1;
          }
        }
      },
      
      process: function(model) {
        var i, ii;

        for (i = 0, ii = model.length; i < ii; i++) {
          model.lastUpdated = $filter('date')(model[i].lastPublishedAt, this.dateFormat);
          model.lastPublished = $filter('date')(model[i].lastPublishedAt, this.dateFormat);
        }

        return model;
      },

      success: {
      
        init: function(response) {},
        
        getLevels: function(response) {
          var self = $scope.membershipLevels;
      
          self.model = self.process(response.data.payload.list);
          self.gridDefinition.options.totalItems = response.data.payload.pagination.count;
          self.gridDefinition.isLoaded = true;
          self.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: self.gridDefinition.options.gridName, 
              datasetLength: self.model.length
            });
          }, 10);

        },

        move: function(response) {},

        remove: function(response) {
          var self = $scope.membershipLevels;
          self.search();
        }
        
      },
      
      error: {
        init: function(response) {},
        getLevels: function(response) {},
        move: function(response) {},
        remove: function(response) {},
        groups: function(response) {
          $scope.membershipLevels.notice.showErrorMessages([{
            message: response.data.error
          }]);
        }
      },

      onSortableUpdate: function(e, data) {
        // next tick
        $timeout(function() {
          $scope.membershipLevels.moveSort();
        }, 0);
      },
      
      onUserPreferencesUpdated: function(e, data) {

        var self = $scope.membershipLevels,
          props = self.gridDefinition.getGridState(), 
          viewState = ViewStateService.getState('membership.levels');

        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        if (viewState && viewState.group && viewState.group === self.tabs[1].name) {
          self.getTab(self.tabs[1].name, true);
        } else {
          self.getTab(self.tabs[0].name, true);
        }
      
      },
      
      onGridDoubleClick: function(item) {
        if (PermissionsService.check('MEMBERSHIP_CATEGORY_UPDATE')) {
          $state.go('application.membership.categories.edit', { id: item.entity.id });
        }
      },
      
      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.membershipLevels;
        self.gridState.updateGridState(newPage, pageSize);
        if (!self.userPreferences || (self.userPreferences.pageSize != pageSize)) {
          self.updateUserPreferences();
        }
        self.getLevels();
      },
      
      onDataGridSortChange: function(grid, columns) {
        var self = $scope.membershipLevels, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.updateUserPreferences();
          self.getLevels();
        }
      },

      onDataGridColumnChanged: function(changedColumn, columns) {},
      
      onDataGridSelectionChange: function(row, e) {},

      onModelUpdate: function(n, o) {
        if (n !== o) {
          $scope.membershipLevels.moveSort();
        }
      },

      onSidebarError: function(e,data) {
        $scope.membershipLevels.error.groups(data);
      },

      onSidebarSelect: function(e,data) {
        var group = (data && data.group),
            self = $scope.membershipLevels;
        self.currentGroup = group;
        self.search();
      },

      onSidebarSuccess: function(e, data) {
        $scope.membershipLevels.notice.showSuccessMessages([{
          message: data.message || 'Successfully Saved!'
        }]);
      }

    };

    $scope.membershipLevels.init();

}]);